import {
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
  Typography,
} from "@mui/material";
import React, { useRef } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { z } from "zod";
// import { maritalStatus } from "../data/data";
import NavigationBtns from "../ui/NavigationBtns";
import { zodResolver } from "@hookform/resolvers/zod";
import { useAuth } from "../contexts/AuthProvider";
import Spinner from "../ui/Spinner";
import { handleNext } from "../utility/navigationUtils";
import { useNavigation } from "../contexts/NavigationProvider";
import { useNavigate } from "react-router-dom";

// Occupation options (id, ar, en)
export const occupations = [
  { id: 1, ar: "طبيب", en: "Doctor" },
  { id: 2, ar: "مهندس", en: "Engineer" },
  { id: 3, ar: "صيدلي", en: "Pharmaceutical" },
  { id: 4, ar: "مقاول بناء", en: "Contractor" },
  { id: 5, ar: "نجار", en: "Carpenter" },
  { id: 6, ar: "حداد", en: "Blacksmith" },
  { id: 7, ar: "عامل مصنع/شركة", en: "LABOURER" },
  { id: 8, ar: "عامل يومية", en: "LABOURER" },
  { id: 9, ar: "موظف حكومة", en: "Public Servant" },
  { id: 10, ar: "موظف مؤسسة عامة", en: "Public Office Servant" },
  { id: 11, ar: "موظف مصلحة عامة", en: "Public Utility Servant" },
  { id: 12, ar: "موظف شركة خاصة", en: "Company Employee" },
  { id: 13, ar: "موظف بنك", en: "BANKER" },
  { id: 14, ar: "طالب", en: "STUDENT" },
  { id: 15, ar: "ربة بيت", en: "HOUSEWIFELY" },
  { id: 16, ar: "موظف دخل عالي", en: "EMPLOYEE" },
  { id: 17, ar: "ميكانيكي", en: "MECHANIC" },
  { id: 18, ar: "كهربائي", en: "ELECTRICAL" },
  { id: 19, ar: "مزارع", en: "FARMER" },
  { id: 20, ar: "سائق", en: "DRIVER" },
  { id: 21, ar: "متقاعد", en: "SUPERNANNUATED" },
  { id: 22, ar: "طيار", en: "AIRMAN" },
  { id: 23, ar: "ممرض", en: "Needle" },
  { id: 24, ar: "محاسب/سوق حساب", en: "Accountant" },
  { id: 25, ar: "فنان", en: "Artist" },
  { id: 26, ar: "تاجر", en: "Commereialize" },
  { id: 27, ar: "معلم", en: "Teacher" },
  { id: 28, ar: "صاحب خانات", en: "Caravansaries" },
  { id: 29, ar: "أدبي", en: "Other" },
  { id: 30, ar: "محامي", en: "Lawyer" },
  { id: 31, ar: "مدير", en: "Administrator" },
  { id: 32, ar: "دعاية وإعلان", en: "Propaganda" },
  { id: 33, ar: "شركات تأمين خاصة", en: "Company insurance" },
  { id: 34, ar: "مختبرات", en: "Laboratories" },
  { id: 35, ar: "مستشفى", en: "Infirmary" },
  { id: 36, ar: "شوارع عامة", en: "Affairs" },
  { id: 37, ar: "ممرض", en: "Infirmary" },
  { id: 38, ar: "أندية", en: "Clubs" },
  { id: 39, ar: "بوفيه", en: "Buffet" },
  { id: 40, ar: "دبلوماسي", en: "Diplomatic" },
  { id: 41, ar: "سياحة وسفر", en: "Tourism" },
  { id: 42, ar: "موظف مكتبات", en: "Bookstores" },
  { id: 43, ar: "ملحق", en: "Attache" },
  { id: 44, ar: "موظف سفينة", en: "Mariner" },
  { id: 45, ar: "موظف تخليص", en: "Extrication" },
  { id: 46, ar: "قاضي", en: "Judge" },
  { id: 47, ar: "بحار", en: "sailar" },
  { id: 48, ar: "رئيس دولة", en: "President" },
  { id: 49, ar: "وزير", en: "Minister" },
  { id: 50, ar: "تعهدات ومقاولات", en: "Commitments" },
  { id: 51, ar: "موظف شركة اتصالات", en: "telecomcompany employee" },
  { id: 52, ar: "اقتصادي", en: "Economist" },
  { id: 53, ar: "خبير مصرفي", en: "Banking Expert" },
  { id: 54, ar: "خبير زراعي", en: "Agricultural" },
  { id: 55, ar: "خبير صناعي", en: "Industrial Expert" },
  { id: 56, ar: "خبير إعلامي", en: "Media Expert" },
  { id: 57, ar: "خبير استراتيجي", en: "Strategic Expert" },
  { id: 58, ar: "مذيع", en: "Announcer" },
  { id: 59, ar: "مندوب مبيعات", en: "Sales Representative" },
  { id: 60, ar: "رئيس قسم", en: "Head of Department" },
  { id: 61, ar: "رجل أعمال", en: "Businessman" },
  { id: 62, ar: "سيدة أعمال", en: "Businesswoman" },
  { id: 63, ar: "مبرمج", en: "Programmer" },
  { id: 64, ar: "مدير عام", en: "Director General" },
  { id: 65, ar: "موظف منظمات", en: "Organizations Employee" },
  { id: 66, ar: "موظف إداري", en: "Adminstrative officer" },
  { id: 67, ar: "ضابط جوي", en: "Adminstrative Air" },
  { id: 68, ar: "كابتن بحري", en: "Nautical Captain" },
  { id: 69, ar: "كابتن بري", en: "Captain Brie" },
  { id: 70, ar: "مضيف جوي", en: "Air Host" },
  { id: 71, ar: "مضيف بري", en: "Wild Host" },
  { id: 72, ar: "أستاذ جامعي", en: "University Professor" },
  { id: 73, ar: "أستاذ مساعد", en: "Assistant Professor" },
  { id: 74, ar: "استشاري اقتصادي", en: "Economic Consultant" },
  { id: 75, ar: "مستشار مصرفي", en: "Banking Advisor" },
  { id: 76, ar: "مستشار زراعي", en: "Agricultural Advisor" },
  { id: 77, ar: "مستشار صناعي", en: "Industrial Consultant" },
  { id: 78, ar: "مستشار إعلامي", en: "Media Consultant" },
  { id: 79, ar: "مستشار استراتيجي", en: "Strategic Advisor" },
  { id: 80, ar: "حارس", en: "sentry" },
  { id: 81, ar: "صحفي", en: "journalist" },
  { id: 82, ar: "ضابط أمن", en: "security officer" },
  { id: 83, ar: "فني تشكيلي", en: "Fineartist" },
  { id: 84, ar: "جزار", en: "Butcher" },
  { id: 85, ar: "إعلامي", en: "Informational" },
  { id: 86, ar: "مدير", en: "Director" },
  { id: 87, ar: "مصور", en: "Photographer" },
  { id: 88, ar: "مدير مبيعات", en: "Sales manager" },
  { id: 89, ar: "بائع", en: "Seller" },
  { id: 90, ar: "موظف استقبال", en: "Receptionist" },
  { id: 91, ar: "بروفيسور", en: "Professor" },
  { id: 92, ar: "سفرجي", en: "Sufruji" },
  { id: 93, ar: "طباخ", en: "Chef" },
  { id: 94, ar: "مترجم", en: "Translation" },
  { id: 95, ar: "مشرف إداري", en: "Administrative Supervisor" },
  { id: 96, ar: "أعمال حرة", en: "Free Business" },
  { id: 97, ar: "مدرب رياضي", en: "Lizarder" },
  { id: 98, ar: "مدرب", en: "Coach" },
  { id: 99, ar: "منقب", en: "Prospector" },
  { id: 100, ar: "صائغ", en: "Jeweler" },
  { id: 101, ar: "مترجم", en: "Translation" },
  { id: 102, ar: "منسق حدائق", en: "Ganden Coordinator" },
  { id: 103, ar: "علاقات عامة", en: "Public Relations" },
  { id: 104, ar: "مراسم", en: "Ceremony" },
  { id: 105, ar: "مؤذن", en: "Muezzin" },
  { id: 106, ar: "إمام جامع", en: "Imam of Mosque" },
  { id: 107, ar: "مبرمج", en: "Programmer" },
  { id: 108, ar: "مستشار قانوني", en: "Counsel" },
  { id: 109, ar: "موظف حكومي", en: "Government Employee" },
  { id: 110, ar: "مدير مكتب", en: "Office Boss" },
  { id: 111, ar: "قاصر", en: "Minor" },
  { id: 112, ar: "مدير طبي", en: "Medical Director" },
  { id: 113, ar: "ممرضة", en: "nurse" },
  { id: 114, ar: "اختصاصي تسويق", en: "Marketing Specialist" },
  { id: 115, ar: "مشير", en: "Marshal" },
  { id: 116, ar: "والي ولاية", en: "Waly Walyah" },
  { id: 117, ar: "برلماني", en: "Parliamentary" },
  { id: 118, ar: "فني", en: "Technician" },
  { id: 119, ar: "مصمم", en: "Designer" },
  { id: 120, ar: "مهندس طيران", en: "Flight Engineer" },
  { id: 121, ar: "أسقف", en: "Bishop" },
  { id: 122, ar: "مدعي عام", en: "Prosecutor" },
  { id: 123, ar: "كبار الضباط", en: "Senior Officers" },
  { id: 124, ar: "قادة الأحزاب", en: "Party Leaders" },
  { id: 125, ar: "مدراء الهيئات الحكومية", en: "Directors Of Government Istitutions" },
  { id: 126, ar: "كبار الشخصيات الدينية", en: "Senior Religious Figures" },
  { id: 127, ar: "السفراء", en: "Ambassadors" },
  { id: 128, ar: "المفوض", en: "Consul" },
  { id: 129, ar: "المفوض السامي", en: "High Commissioner" },
  { id: 130, ar: "كبار مسؤولي الجهات السياسية", en: "Political Parties" },
  { id: 131, ar: "كبار مسؤولي الدولة", en: "Senier Management And Boarel Of state" },
  { id: 132, ar: "مدراء الهيئات الرسمية", en: "Senior Offical Ingos" },
  { id: 133, ar: "رؤساء البلديات وأعضاء المجالس المحلية", en: "Mayors And Members Of Local Country" },
  { id: 134, ar: "رؤساء الهيئات القضائية العسكرية وإنفاذ القانون", en: "Head Of Military Judiciary Law Enforcem" },
  { id: 135, ar: "وكيل الوزارة", en: "Undersecretary of the Ministry" },
];

type TPersonalInfo2Props = {
  setPersonalInfoStep: React.Dispatch<React.SetStateAction<number>>;
};

export default function PersonalInfo2({
  setPersonalInfoStep,
}: TPersonalInfo2Props) {
  const { t, i18n } = useTranslation();
  const { setSubmittedData, submittedData } = useAuth();


  const { setCurrentStep, currentStep, steps, } = useNavigation();
  const [selectedMaritalStatus, setSelectedMaritalStatus] = React.useState(submittedData.maritalStatus || "");
  const navigate = useNavigate();
  const maritalStatus = [
    { id: 1, title: t('single'), value: "Single" },
    { id: 2, title: t('married'), value: "Married" },
    { id: 3, title: t('divorced'), value: "Divorced" },
    { id: 4, title: t('widowed'), value: "Widowed" },
  ];
  const branches = [
    { code: "2", title: t("port_sudan") },
    { code: "3", title: t("gadaref") },
    { code: "4", title: t("white_nile") },
    { code: "5", title: t("wad_madani") },
    { code: "6", title: t("omdurman") },
    { code: "7", title: t("damazin") },
    { code: "8", title: t("managil") },
    { code: "9", title: t("sinnar") },
    { code: "10", title: t("nyala") },
    { code: "11", title: t("halfa_jadida") },
    { code: "12", title: t("sajana") },
    { code: "13", title: t("rabak") },
    { code: "14", title: t("hasahisa") },
    { code: "15", title: t("souk_libya") },
    { code: "16", title: t("khartoum") },
    { code: "17", title: t("khartoum_2") },
    { code: "18", title: t("khartoum_bahri") },
    { code: "19", title: t("jumhuriya") },
    { code: "20", title: t("local_market") },
    { code: "21", title: t("garden_city") },
    { code: "22", title: t("riyadh") },
    { code: "23", title: t("atbara") },
    { code: "24", title: t("mamoura") },
    { code: "25", title: t("janeed") },
    { code: "26", title: t("kadro") },
  ];

  const schma = z.object({
    address: z.string().min(5, {
      message:
        i18n.language === "en" ? "Address is required." : "العنوان مطلوب.",
    }),
    occupation: z
      .number({
        required_error: i18n.language === "en" ? "Occupation is required." : "المهنة مطلوبة.",
        invalid_type_error: i18n.language === "en" ? "Occupation is required." : "المهنة مطلوبة.",
      })
      .refine((val) => {
        return occupations.some((occ) => occ.id === val);
      }, {
        message: i18n.language === "en" ? "Invalid occupation selected." : "المهنة غير صحيحة.",
      }),
    employer: z.string().min(1, {
      message:
        i18n.language === "en"
          ? "Employer is required."
          : "الجهة العاملة مطلوبة.",
    }).refine((val) => {
      return !/\d/.test(val);
    }, {
      message: i18n.language === "en" ? "Employer cannot contain numbers." : "الجهة العاملة لا يمكن أن تحتوي على أرقام.",
    }),
    averageIncome: z
      .string()
      .regex(/^\d*\.?\d*$/, {
        message: i18n.language === "en" ? "Invalid format." : "صيغة غير صالحة.",
      })
      .refine((val) => {
        // Accept empty string (optional), or a number > 0
        if (!val) return false;
        const num = Number(val);
        return !isNaN(num) && num > 0;
      }, {
        message: i18n.language === "en" ? "Income must be greater than 0." : "الدخل يجب أن يكون أكبر من 0.",
      }),
    MotherName: z.string().min(1, {
      message: i18n.language === "en" ? "Mother name is required." : "اسم الأم مطلوب.",
    }).refine((val) => {
      return !/\d/.test(val); // No numbers allowed
    }, {
      message: i18n.language === "en" ? "Mother name cannot contain numbers." : "اسم الأم لا يمكن أن يحتوي على أرقام.",
    }),
    partnerName: z.string().refine((val) => {
      if (selectedMaritalStatus !== "Married") return true;
      if (!val) return false;
      if (/\d/.test(val)) return false; // No numbers allowed
      return true;
    }, {
      message: i18n.language === "en"
        ? "Partner name is required and cannot contain numbers."
        : "اسم الزوج مطلوب ولا يمكن أن يحتوي على أرقام.",
    }),
    maritalStatus: z.string().min(1, {
      message: t('maritalStatusErrorMessage')
    }),
    placeOfResidency: z.string().optional(),
    branch: z.string().min(1, {
      message: i18n.language === "en" ? "Branch is required." : "الفرع مطلوب.",
    }),
  });
  type FormFields = z.infer<typeof schma>;
  const {
    handleSubmit,
    formState: { isSubmitting, errors },
    trigger,
    control,
    register,
    setValue,
  } = useForm<FormFields>({
    resolver: zodResolver(schma),
    defaultValues: {
      MotherName: submittedData.MotherName,
      occupation: typeof submittedData.occupation === 'number' ? submittedData.occupation : undefined,
      address: submittedData.address,
      averageIncome: submittedData.averageIncome,
      employer: submittedData.employer,
      partnerName: submittedData.partnerName,
      maritalStatus: submittedData.maritalStatus,
      placeOfResidency: submittedData.placeOfResidency
    },
  });

  const averageIncomeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (
      (/^\d*\.?\d+$/.test(value) && value.length <= 15) ||
      value[value.length - 1] === "."
    ) {
      setValue("averageIncome", value, { shouldValidate: true });
    } else
      setValue("averageIncome", value.slice(0, value.length - 1), {
        shouldValidate: true,
      });
  };

  const handleChange = (field: string) => (event: SelectChangeEvent<string>) => {
    setSubmittedData({
      ...submittedData,
      [field]: event.target.value,
    });
    if (field === "maritalStatus") {
      setSelectedMaritalStatus(event.target.value);
    }
  };

  const submitFunction = (formdata: FormFields) => {
    setSubmittedData({
      ...submittedData, // Spread the existing submittedData first
      MotherName: formdata.MotherName ? formdata.MotherName : "",
      partnerName: formdata.partnerName ? formdata.partnerName : "",
      occupation: formdata.occupation, // int id
      address: formdata.address,
      averageIncome: formdata.averageIncome,
      employer: formdata.employer,
      placeOfResidency: formdata.placeOfResidency ? formdata.placeOfResidency : "N/A",
      branch: formdata.branch,
    });
    console.log('occupation:', formdata.occupation);
    setPersonalInfoStep(2);
    handleNext(setCurrentStep, currentStep.step, steps, navigate);
  };

  const addressRef = useRef<HTMLInputElement>(null);
  const employerRef = useRef<HTMLInputElement>(null);
  const averageIncomeRef = useRef<HTMLInputElement>(null);
  const maritialStatusRef = useRef<HTMLSelectElement>(null);
  const occupationRef = useRef<HTMLDivElement>(null);

  // Refs for name inputs
  const motherNameRef = useRef<HTMLInputElement>(null);
  const partnerNameRef = useRef<HTMLInputElement>(null);

  const handleKeyDown = (e: any, nextRef: any) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      nextRef.current.focus();
    }
  };

  return (
    <>
      {isSubmitting ? <Spinner /> : null}
      <form
        onSubmit={handleSubmit(submitFunction)}
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          flexGrow: 1,
        }}
      >
        <Typography variant="body1" color="initial" m={0} p={0} fontSize={10}>
          {t("MotherName")}
        </Typography>
        <TextField
          type="text"
          placeholder={t("MotherName")}
          error={errors.MotherName?.message !== undefined}
          helperText={errors.MotherName ? errors.MotherName.message : ""}
          {...register("MotherName")}
          sx={{ borderRadius: "10px", margin: 0, fontSize: "12px", marginBottom: "8px" }}
          tabIndex={1}
          inputRef={motherNameRef}
          onBlur={async () => {
            await trigger("MotherName");
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              maritialStatusRef.current?.focus();
            }
          }}
        />
        <FormControl fullWidth>
          <Typography variant="body1" color="initial" m={0} p={0} fontSize={10}>
            {t('maritalStatus')}
          </Typography>
          <Controller
            name="maritalStatus"
            control={control}
            render={({ field }) => (
              <Select
                {...field}
                value={field.value || ""}
                onChange={(e) => {
                  field.onChange(e);
                  handleChange("maritalStatus")(e);
                }}
                label={t('maritalStatus')}
                error={!!errors.maritalStatus}
                tabIndex={2}
                inputRef={maritialStatusRef}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    if (selectedMaritalStatus !== "Single") {
                      partnerNameRef.current?.focus();
                    } else {
                      occupationRef.current?.focus();
                    }
                  }
                }}
              >
                {maritalStatus.map((status) => (
                  <MenuItem key={status.id} value={status.value}>
                    {status.title}
                  </MenuItem>
                ))}
              </Select>
            )}
          />
        </FormControl>
        {selectedMaritalStatus !== "Single" && (
          <>
            <Typography variant="body1" color="initial" m={0} p={0} fontSize={10}>
              {t('partnerName')}
            </Typography>
            <TextField
              type="text"
              placeholder={t('partnerName')}
              error={errors.partnerName?.message !== undefined}
              helperText={errors.partnerName ? errors.partnerName.message : ""}
              {...register("partnerName")}
              sx={{ borderRadius: "10px", margin: 0, fontSize: "12px", marginBottom: "8px" }}
              tabIndex={3}
              inputRef={partnerNameRef}
              onBlur={async () => {
                await trigger("partnerName");
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  occupationRef.current?.focus();
                }
              }}
            />
          </>
        )}

        <Typography variant="body1" color="initial" m={0} p={0} fontSize={10}>
          {t("occupation")}
        </Typography>
        <FormControl fullWidth>
          <Controller
            name="occupation"
            control={control}
            render={({ field }) => (
              <Select
                {...field}
                value={field.value ?? ''}
                onChange={(e) => {
                  const value = e.target.value === '' ? undefined : Number(e.target.value);
                  field.onChange(value);
                  setSubmittedData({ ...submittedData, occupation: value });
                }}
                error={!!errors.occupation}
                tabIndex={4}
                inputRef={occupationRef}
                onKeyDown={(e) => handleKeyDown(e, addressRef)}
                displayEmpty
              >
                <MenuItem value="" disabled>
                  {t("occupation")}
                </MenuItem>
                {occupations.map((occ) => (
                  <MenuItem key={occ.id} value={occ.id}>
                    {i18n.language === 'ar' ? occ.ar : occ.en}
                  </MenuItem>
                ))}
              </Select>
            )}
          />
          {errors.occupation && (
            <Typography color="error" fontSize={12}>
              {errors.occupation.message}
            </Typography>
          )}
        </FormControl>
        <Typography variant="body1" color="initial" m={0} p={0} fontSize={10}>
          {t("address")}
        </Typography>
        <TextField
          type="text"
          id="address"
          error={errors.address?.message !== undefined}
          helperText={errors.address ? errors.address.message : ""}
          {...register("address")}
          sx={{ borderRadius: "10px", margin: 0, fontSize: "12px" }}
          onBlur={async () => {
            await trigger("address");
          }}
          tabIndex={4}
          inputRef={addressRef}
          onKeyDown={(e) => handleKeyDown(e, employerRef)}
        />
        <Typography variant="body1" color="initial" m={0} p={0} fontSize={10}>
          {t("employer")}
        </Typography>
        <TextField
          type="text"
          id="employer"
          error={errors.employer?.message !== undefined}
          helperText={errors.employer ? errors.employer.message : ""}
          {...register("employer")}
          sx={{ borderRadius: "10px", margin: 0, fontSize: "12px" }}
          onBlur={async () => {
            await trigger("employer");
          }}
          tabIndex={5}
          inputRef={employerRef}
          onKeyDown={(e) => handleKeyDown(e, averageIncomeRef)}
        />
        <Typography variant="body1" color="initial" m={0} p={0} fontSize={10}>
          {t("averageIncome")}
        </Typography>
        <TextField
          type="tel"
          id="averageIncome"
          error={errors.averageIncome?.message !== undefined}
          helperText={errors.averageIncome ? errors.averageIncome.message : ""}
          {...register("averageIncome")}
          sx={{
            borderRadius: "10px",
            margin: 0,
            fontSize: "12px",
            marginBottom: "1rem",
          }}
          tabIndex={6}
          onBlur={async () => {
            await trigger("averageIncome");
          }}
          onChange={averageIncomeChange}
          inputRef={averageIncomeRef}
          onKeyDown={(e) => handleKeyDown(e, null)}
        />
        <Typography variant="body1" color="initial" m={0} p={0} fontSize={10}>
          {t("closestbranch")}
        </Typography>
        <Controller
          name="branch"
          control={control}
          render={({ field }) => (
            <Select
              {...field}
              value={field.value || ""}
              onChange={(e) => {
                field.onChange(e);
                handleChange("branch")(e);
              }}
              label={t("closestbranch")}
              error={!!errors.placeOfResidency}
              tabIndex={7}
            >
              {branches.map((branch) => (
                <MenuItem key={branch.code} value={branch.code}>
                  {branch.title}
                </MenuItem>
              ))}
            </Select>
          )}
        />
        <br />
        <br />
        <br />
        <br />
        <br />
        <NavigationBtns isSubmitting={isSubmitting} />
      </form>
    </>
  );
}
